import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  notselectable: {
    userSelect: 'none',
  },
}));

export default function NoSelect(props) {
  const classes = useStyles();

  return (
    <span className={classes.notselectable}>{props.children}</span>
  );
}
